module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0032.jpg?v=2b2af233";